import React from 'react';
import Title from '../Title/Title';

import * as S from './OfficeAddress.styles';

const OfficeAddress = ({currentLang}) => {
  return (
    <S.Container>
      <Title
        title={currentLang === 'arabic' ? '' : 'Gurgaon'}
        subTitle={currentLang === 'arabic' ? '(المقر الرئيسي)' : '(Head Office)'}
      />
      <p>
        {currentLang === 'arabic'
          ? `شركة ميكمايتريب إنديا ذ.م.م، مبنى دي ال اف، رقم ،5 برج بي دي ال اف، سايبر سيتي، القطاع 25، غوروغرام، ولاية هاريانا، ص.ب 122002، الهند`
          : `MakeMyTrip India Pvt. Ltd.,DLF Building No. 5 Tower BDLF Cyber City, DLF Phase 2Sector 25,
        Gurugram, Haryana 122002, India`}
      </p>
      <S.ContentRight>
        <h4>
          {currentLang === 'arabic'
            ? 'خط المساعدات (الإمارات العربية المتحدة)'
            : 'HELP LINE (UAE):'}
        </h4>
        <p>
          <span>
            {currentLang === 'arabic'
              ? '600521404 971+, 8000180004 971+'
              : '+971 600521404, +971 8000180004'}{' '}
            -
          </span>{' '}
          {currentLang === 'arabic'
            ? `من 9:00 صباحًا إلى 9:00 مساءً بتوقيت الخليج القياسي`
            : 'All UAE operators (9:00 AM to 9:00 PM GST)'}
        </p>
      </S.ContentRight>
    </S.Container>
  );
};

export default OfficeAddress;
